/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Item_Responsive_Indicator_DescInputs */

const en_dev_item_responsive_indicator_desc = /** @type {(inputs: Dev_Item_Responsive_Indicator_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show breakpoint indicator in the corner`)
};

const ar_dev_item_responsive_indicator_desc = /** @type {(inputs: Dev_Item_Responsive_Indicator_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إظهار مؤشر نقاط التوقف في الزاوية`)
};

const bn_dev_item_responsive_indicator_desc = /** @type {(inputs: Dev_Item_Responsive_Indicator_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোণায় ব্রেকপয়েন্ট ইন্ডিকেটর দেখান`)
};

const de_dev_item_responsive_indicator_desc = /** @type {(inputs: Dev_Item_Responsive_Indicator_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haltepunktanzeige in der Ecke anzeigen`)
};

const es_dev_item_responsive_indicator_desc = /** @type {(inputs: Dev_Item_Responsive_Indicator_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar indicador de punto de interrupción en la esquina`)
};

const fr_dev_item_responsive_indicator_desc = /** @type {(inputs: Dev_Item_Responsive_Indicator_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher l'indicateur de point d'arrêt dans le coin`)
};

const pt_dev_item_responsive_indicator_desc = /** @type {(inputs: Dev_Item_Responsive_Indicator_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar indicador de ponto de interrupção no canto`)
};

const zh_dev_item_responsive_indicator_desc = /** @type {(inputs: Dev_Item_Responsive_Indicator_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在角落显示断点指示器`)
};

const tr_dev_item_responsive_indicator_desc = /** @type {(inputs: Dev_Item_Responsive_Indicator_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Köşede kesme noktası göstergesini göster`)
};

const ru_dev_item_responsive_indicator_desc = /** @type {(inputs: Dev_Item_Responsive_Indicator_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показывать индикатор точки останова в углу`)
};

const pl_dev_item_responsive_indicator_desc = /** @type {(inputs: Dev_Item_Responsive_Indicator_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż wskaźnik punktu przerwania w rogu`)
};

/**
* | output |
* | --- |
* | "Show breakpoint indicator in the corner" |
*
* @param {Dev_Item_Responsive_Indicator_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dev_item_responsive_indicator_desc = /** @type {((inputs?: Dev_Item_Responsive_Indicator_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Item_Responsive_Indicator_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dev_item_responsive_indicator_desc(inputs)
	if (locale === "bn") return bn_dev_item_responsive_indicator_desc(inputs)
	if (locale === "de") return de_dev_item_responsive_indicator_desc(inputs)
	if (locale === "es") return es_dev_item_responsive_indicator_desc(inputs)
	if (locale === "fr") return fr_dev_item_responsive_indicator_desc(inputs)
	if (locale === "pt") return pt_dev_item_responsive_indicator_desc(inputs)
	if (locale === "zh") return zh_dev_item_responsive_indicator_desc(inputs)
	if (locale === "tr") return tr_dev_item_responsive_indicator_desc(inputs)
	if (locale === "ru") return ru_dev_item_responsive_indicator_desc(inputs)
	if (locale === "pl") return pl_dev_item_responsive_indicator_desc(inputs)
	return en_dev_item_responsive_indicator_desc(inputs)
});